// React and Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";

// Libs
import { ButtonSpocket } from "shared_components";
import { Row, Col } from "react-bootstrap";

// Icons
import checkMark from "../../../../assets/checked-1.svg";
import locationIcon from "../../../../assets/locationIcon.svg";
import moneyIcon from "../../../../assets/moneyIcon.svg";
import newIcon from "../../../../assets/newIcon.svg";
import tagIcon from "../../../../assets/tagIcon.svg";

// Components
import { default as Loadable } from "../../../_Shared/commonLoadable";
import CreditCard from "../../CreditCard";
import InputAddress from "../../Forms/inputAddress";
import ModalWrapper from "../../ModalWrapper";
import OrderReview from "../../Forms/orderReview";
import PaymentComplete from "../../Forms/paymentComplete";
import ProductVariation from "../../Forms/productVariation";

// Actions
import { closeModal } from "../../../../actions/ui";
import { updateForm, cleanForm } from "../../../../actions/forms";

// API Call
import StoreApiCall from "../../../../utils/storeApiCall";

import { withTranslation } from 'react-i18next';

// Style
import "./style.css";
import {
  placeSampleOrder,
  cleanConfirmation
} from "../../../../newDropshipperApp/module/store/order";

class SampleOrderModal extends Component {
  state = {
    currentStep: 0,
    variationSelected: "",
    isLoading: false,
    orderSample: {
      characteristics: {}
    },
    paymentConfirmationLink: null
  };

  /**
   * All of our modals are a Bootstrap component.
   * When we open or close a modal it changes the <body> </ body> HTML tag
   * When we open a modal it adds the class modal-open and when we close it
   * removes that class. That being said, when we close the sample order modal
   * the bootstrap removes the modal-open class from the <body> </ body> HTML
   * tag and this make the product details modal not work properly (since at this moment there are two open modals).
   *
   * The solution to this problem was to add the overflow: none style 100 milliseconds
   * after the sample order modal is unmounted.
   */
  componentWillUnmount() {
    setInterval(
      () => document.body.setAttribute("style", "overflow: none"),
      100
    );
  }

  handleFormChanged = event => {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    let fieldLabel = event.target.label;
    const currentForm = ["PRODUCT_VARIATION", "INPUT_ADDRESS"];
    // Check what step and update the right form
    this.props.updateForm(currentForm[this.state.currentStep], {
      [fieldName]: fieldValue
    });
    this.props.updateForm("INFORMATIONS", { [fieldName]: fieldLabel });
  };

  handleListingSelected = listing => {
    this.props.updateForm("INFORMATIONS", {
      listingSelected: listing
    });
  };

  handleVariantSelected = product => {
    this.props.updateForm("INFORMATIONS", {
      productSelected: product
    });
  };

  handleStripeCardAssignment = card => {
    this.props.updateForm("INFORMATIONS", { card: card });
  };

  handleOrderReviewLoaded = bool => {
    this.props.updateForm("INFORMATIONS", { orderReviewLoaded: bool });
  };

  steps = [
    {
      icon: newIcon,
      component: (
        <ProductVariation
          handleFormChanged={this.handleFormChanged}
          handleListingSelected={this.handleListingSelected}
          handleVariantSelected={this.handleVariantSelected}
          state={this.state}
        />
      )
    },
    {
      icon: locationIcon,
      component: <InputAddress handleFormChanged={this.handleFormChanged} />
    },
    {
      icon: moneyIcon,
      component: (
        <CreditCard
          renderModal={false}
          includeSubtext={false}
          handleStripeCardAssignment={this.handleStripeCardAssignment}
        />
      )
    },
    {
      stepText: "Final Step",
      icon: tagIcon,
      component: (
        <OrderReview handleOrderReviewLoaded={this.handleOrderReviewLoaded} />
      )
    },
    {
      icon: checkMark,
      component: <PaymentComplete />
    }
  ];

  footerStyle = {
    backgroundColor: "#f2f2fa",
    padding: "20px 25px 20px 25px",
    borderRadius: "6px"
  };

  nextStep = () => {
    const { currentStep } = this.state;
    currentStep < this.steps.length - 1 &&
      this.setState({ currentStep: currentStep + 1 });
  };

  prevStep = () => {
    const { currentStep } = this.state;

    if (currentStep === 3) {
      this.handleOrderReviewLoaded(false);
    }

    if (currentStep > 0) {
      this.setState({ currentStep: currentStep - 1 });
    } else {
      this.props.closeModal();
      this.props.cleanForm();
    }
  };

  // TODO - improve this code
  currentAction = () => {
    const { currentStep } = this.state;
    const { inputAddress } = this.props.form;
    if (currentStep === 0) {
      this.nextStep();
    } else if (currentStep === 1) {
      inputAddress.line_one ? this.updateAddress() : this.saveAddress();
    } else if (currentStep === 2) {
      this.nextStep();
    } else if (currentStep === 3) {
      this.placeOrder();
    } else if (currentStep === 4) {
      this.props.closeModal();
      this.props.cleanForm();
      this.props.cleanConfirmation();
    }
  };

  // TODO - improve this code
  isButtonDisabled() {
    const { currentStep } = this.state;
    const form = this.props.form;
    const isAddressFormValid = Object.keys(form.inputAddress).every(
      k => form.inputAddress[k]
    );

    if (form.characteristics && form.quantity && currentStep === 0) {
      return false;
    } else if (isAddressFormValid && currentStep === 1) {
      return false;
    } else if (form.card && currentStep === 2) {
      return false;
    } else if (form.orderReviewLoaded && currentStep === 3) {
      return false;
    } else if (currentStep === 4) {
      return false;
    } else {
      return true;
    }
  }

  setLoading(isLoading) {
    this.setState({ isLoading });
  }

  // Step 2 - Input Address
  saveAddress() {
    this.setLoading(true);
    const { inputAddress } = this.props.form;
    StoreApiCall.validateAddress(inputAddress)
      .then(() => {
        StoreApiCall.saveAddress(inputAddress);
        this.setLoading(false);
        this.nextStep();
      })
      .catch(error => {
        this.setLoading(false);
        this.props.setAlertMessage(error.json.errors, "error");
      });
  }

  updateAddress() {
    this.setLoading(true);
    const { inputAddress } = this.props.form;
    StoreApiCall.validateAddress(inputAddress)
      .then(() => {
        StoreApiCall.updateAddress(inputAddress);
        this.setLoading(false);
        this.nextStep();
      })
      .catch(error => {
        this.setLoading(false);
        this.props.setAlertMessage(error.json.errors, "error");
      });
  }

  placeOrderSuccess = () => {
    this.setLoading(false);
    this.nextStep();
  };

  placeOrderFailure = () => {
    this.setLoading(false);
  };

  // Step 4 - Order Review
  placeOrder = () => {
    const form = this.props.form;
    const address = form.inputAddress;
    this.setLoading(true);
    const data = {
      integrated_store_id: localStorage.getItem("integrated_store_id"),
      listing_id: form.listingSelected.id,
      quantity: form.quantity,
      phone_number: address.phone,
      note: form.productVariation.note,
      variation_id: form.productSelected.id,
      address: {
        ...address
      }
    };
    this.props.placeSampleOrder(
      data,
      this.placeOrderSuccess,
      this.placeOrderFailure
    );
  };

  renderTitle = () => {
    const { paymentConfirmationRequired, t } = this.props
    const { currentStep } = this.state;

    if (currentStep === 0) {
      return t("SampleOrderModal.Title.SelectVariation")
    } else if (currentStep === 1) {
      return t("SampleOrderModal.Title.ShippingAddress")
    } else if (currentStep === 2) {
      return t("SampleOrderModal.Title.PaymentMethod")
    } else if (currentStep === 3) {
      return t("SampleOrderModal.Title.Review")
    } else if (currentStep === 4 && paymentConfirmationRequired) {
      return t("SampleOrderModal.Title.PaymentConfirmationRequired")
    } else if (currentStep === 4 && !paymentConfirmationRequired) {
      return t("SampleOrderModal.Title.OrderPlaced")
    }
  }

  rendeStepText = () => {
    const { paymentConfirmationRequired, t } = this.props
    const { currentStep } = this.state;
    const totalSteps = 4

    if (currentStep < (totalSteps - 1)) {
      return t("SampleOrderModal.Steps", { current: currentStep + 1, total: totalSteps })
    } else if (currentStep === 3) {
      return t("SampleOrderModal.FinalStep")
    } else if (currentStep === 4 && paymentConfirmationRequired) {
      return t("SampleOrderModal.ConfirmPayment")
    } else if (currentStep === 4 && !paymentConfirmationRequired) {
      return t("SampleOrderModal.Finished")
    }
  }

  render() {
    const { currentStep } = this.state;
    const { icon, component } = this.steps[currentStep];
    const title = this.renderTitle(currentStep)
    const stepText = this.rendeStepText(currentStep)

    return (
      <ModalWrapper
        size="small Sample_Order_Modal__modal"
        onHide={() => this.props.cleanForm()}
      >
        <Loadable active={this.state.isLoading}>
          <ModalWrapper.Header>
            <img
              src={icon}
              alt=""
              style={{ marginRight: "10px", maxHeight: "25px" }}
            />
            <span className="Sample_Order_Modal__title-modal">{title}</span>
          </ModalWrapper.Header>
          <ModalWrapper.Body>{component}</ModalWrapper.Body>
          <ModalWrapper.Footer style={this.footerStyle}>
            <Row>
              <Col style={{ textAlign: "left", height: "35px" }} md={4}>
                <span style={{ position: "absolute", top: "25%" }}>
                  {stepText}
                </span>
              </Col>
              <Col md={8}>{this.renderFooterButtons()}</Col>
            </Row>
          </ModalWrapper.Footer>
        </Loadable>
      </ModalWrapper>
    );
  }

  renderFooterButtons() {
    const { currentStep } = this.state;
    const { t } = this.props;

    let continueButtonText = t("SampleOrderModal.Footer.Continue");
    if (currentStep === 3) {
      continueButtonText = t("SampleOrderModal.Footer.PlaceOrder");
    } else if (currentStep === 4) {
      continueButtonText = t("SampleOrderModal.Footer.Close");
    }
    return (
      <div>
        {currentStep < 4 && (
          <ButtonSpocket
            customButton={{ height: "35px" }}
            bsStyle="secondary"
            bsSize="sm"
            onClick={this.prevStep}
          >
            {currentStep === 0 ? t("SampleOrderModal.Footer.Cancel") : t("SampleOrderModal.Footer.GoBack")}
          </ButtonSpocket>
        )}
        <ButtonSpocket
          disabled={this.isButtonDisabled()}
          customButton={{ height: "35px" }}
          bsStyle="primary"
          bsSize="sm"
          onClick={this.currentAction}
        >
          {continueButtonText}
        </ButtonSpocket>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateForm,
      closeModal,
      cleanForm,
      placeSampleOrder,
      cleanConfirmation
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    form: state.forms,
    paymentConfirmationRequired: state.order.paymentConfirmationRequired
  };
}

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(SampleOrderModal));



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/SampleOrderModal/index.js